// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/calendar-days.js';

import { paths } from '../generated/calendar-days';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('calendar-days', Original, paths);
